import { render, staticRenderFns } from "./IconCsv.vue?vue&type=template&id=33920b08"
import script from "./IconCsv.vue?vue&type=script&lang=js"
export * from "./IconCsv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports